import React from 'react';

import { useTranslation } from 'react-i18next';

import { PromotionWinnerType } from '@types';

import { CupFilledIcon } from '@components/icons';

import * as Styled from './main-winner-card.styled';

type OwnProps = {
	winner: PromotionWinnerType;
};

const MainWinnerCard: React.FC<OwnProps> = ({ winner }) => {
	const { t } = useTranslation('main');

	return (
		<Styled.Wrapper $place={winner.position}>
			<Styled.Description>{t('participant')}</Styled.Description>
			<Styled.MainText>{winner.user_pm_id}</Styled.MainText>
			<Styled.Description>{t('prize')}</Styled.Description>
			<Styled.MainText>
				<Styled.CupIconWrapper>
					<CupFilledIcon />
				</Styled.CupIconWrapper>
				{winner.prize_name}
			</Styled.MainText>
		</Styled.Wrapper>
	);
};

export default MainWinnerCard;
